import React, { useState, useEffect } from "react";
import axios from "axios";
import apiUrl from "../../../config/config";
import moment from "moment";
import "./ReportsCompleted.css";
import Loading from "./Loading";

const DailyCount = () => {
  const [analysedData, setAnalysedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD")); // Calendar state
  const [runLoading, setRunLoading] = useState(false);
  const dataPerPage = 8;
  const maxPageNumbersToShow = 8;

  const fetchAnalysedStatus = async (isMounted) => {
    setLoading(true);
    try {
      // Call RunVerifierDaily before loading data
      await axios.post(`${apiUrl}api/users/RunVerifierDaily`);
      const response = await axios.get(
        `${apiUrl}api/users/getverifierDetailsDaily`
      );
      const verifierType = localStorage.getItem("verifiertype");
      const verifierId = localStorage.getItem("verifierid");

      // Filter and map API data by selected date
      const filteredApiData = (response.data || [])
        .filter(item => {
          // Filter by verifier type/id
          if (verifierType === "8") {
            return true;
          } else if (verifierType === "2") {
            return item.verifierId === verifierId;
          }
          return false;
        })
        .filter(item => {
          // Filter by selected date
          return moment(item.datetime, "MM/DD/YYYY HH:mm:ss").format("YYYY-MM-DD") === selectedDate;
        })
        .map((item, idx) => ({
          serialNo: idx + 1,
          verifierName: item.name || "N/A",
          totalHoursVerified: item.totalCount,
          patientsVerified: item.filteredCount,
          dateTime: item.datetime
        }));

      if (isMounted.current) {
        setAnalysedData(filteredApiData);
        setFilteredData(filteredApiData);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching analysed status:", error);
      if (isMounted.current) setLoading(false);
    }
  };

  const runVerifierDaily = async () => {
    setRunLoading(true);
    try {
      await axios.post(`${apiUrl}api/users/RunVerifierDaily`);
      // Optionally, refresh the data after running
      fetchAnalysedStatus({ current: true });
    } catch (error) {
      console.error("Error running RunVerifierDaily:", error);
    }
    setRunLoading(false);
  };

  const handleDateChange = async (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    setCurrentPage(1);
    setRunLoading(true);
    try {
      await axios.post(`${apiUrl}api/users/RunVerifierDaily`);
    } catch (error) {
      console.error("Error running RunVerifierDaily:", error);
    }
    setRunLoading(false);
    // fetchAnalysedStatus will be triggered by useEffect after setSelectedDate
  };

  useEffect(() => {
    const isMounted = { current: true };
    fetchAnalysedStatus(isMounted);
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line
  }, [selectedDate]);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const totalPages = Math.ceil(filteredData.length / dataPerPage);
  const startPage = Math.max(
    1,
    currentPage - Math.floor(maxPageNumbersToShow / 2)
  );
  const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);
  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, index) => startPage + index
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="reports-completed">
      <div style={{ marginBottom: "16px", display: "flex", alignItems: "center" }}>
        <label style={{ color: "white", marginRight: "8px" }}>Select Date:</label>
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          style={{ padding: "4px", borderRadius: "4px" }}
          disabled={runLoading}
        />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <table className="reports-table">
            <thead>
              <tr>
                <th>Serial No</th>
                <th>Verifier Name</th>
                <th>Total Hours Verified</th>
                <th>No. of Patients Verified</th>
                <th>Date &amp; Time</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((data, index) => (
                <tr key={index}>
                  <td>{indexOfFirstData + index + 1}</td>
                  <td>{data.verifierName}</td>
                  <td>{data.totalHoursVerified}</td>
                  <td>{data.patientsVerified}</td>
                  <td>
                    {moment(data.dateTime, "MM/DD/YYYY HH:mm:ss").format("MMM DD, YYYY HH:mm:ss")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="reports-pagination">
            {pageNumbers.map((number) => (
              <button
                key={number}
                onClick={() => paginate(number)}
                className={currentPage === number ? "active" : ""}
              >
                {number}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default DailyCount;
